<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import { useTranslations } from 'dashboard/composables/useTranslations';

const { content, contentAttributes, createdAt } = useMessageContext();
const { hasTranslations, translationContent } =
  useTranslations(contentAttributes);

const renderContent = computed(() =>
  hasTranslations.value ? translationContent.value : content.value
);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span :title="renderContent">{{ renderContent }}</span>
  </BaseBubble>
</template>
